import { t } from 'i18next';
import { z } from 'zod';

export const ReservationFormSchema = z
	.object({
		apartmentId: z
    .array(z.object({
      id: z.string(),
      name: z.string().optional()
    })).min(1, { message: t('elements.form.apartments.error') }), 
		checkInDate: z.date({ message: t('elements.form.startDate.error') }),
		checkOutDate: z.date({ message: t('elements.form.endDate.error') }),
		reservationForSomeoneElse: z.boolean(),
		guestFullName: z.string().optional(),
		remarks: z.string().optional(),
	})
	.refine(
		(data) =>
			data.checkInDate && data.checkOutDate
				? data.checkOutDate >= data.checkInDate
				: true,
		{
			message: t('elements.form.datesDifference.error'),
			path: ['checkOutDate'],
		},
	)
	.refine(
		(data) =>
			data.reservationForSomeoneElse
				? !!data.guestFullName?.length
				: true,
		{
			message: 'Guest full name is needed.',
			path: ['guestFullName'],
		},
	);
